import axios from "axios";

const publicApi = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  /**
   * Needed for the guest portal's session cookie, which the API sets HTTP-only
   * and cross-site. Without this axios neither stores nor sends it, so every
   * portal request after sign-in comes back 401 with nothing on the page to
   * explain why. Safe on the other public routes: they set no cookies, and the
   * API's CORS allowlist is what decides whose credentials are accepted.
   */
  withCredentials: true,
});

export default publicApi;